import { useEffect, useId, useMemo, useRef, useState } from "react";

import { StarIcon } from "../../assets/icon/svg";

import "./style.css";

interface IProps {
    onChangeRate?: (value: number) => void;
    value: number;
    disabled?: boolean;
    style?: any;
    labelStyle?: any;
    size?: number;
    isRating?: boolean;
}
const Star = ({ value, disabled, style, labelStyle, size, isRating, onChangeRate }: IProps) => {
    const [val, setVal] = useState<number>(value || 0);
    const wrapperRef = useRef<any>(null);
    const handleChangeRate = (e: any) => {
        setVal(Number(e.target.value));
        onChangeRate && onChangeRate(Number(e.target.value));
    };

    useEffect(() => { }, [val]);

    const CustomStar = () => <StarIcon width={size} height={size} />;
    const id = useId();

    const ratingContainerClass = useMemo(() => {
        const className = ["rating-rate"];
        if (isRating) className.push("rating-comment");
        return className.join(" ");
    }, [isRating]);

    const labelClass = useMemo(() => {
        const className = [];
        if (disabled) className.push("disabled");
        return className.join(" ");
    }, [disabled]);


    return (
        <div className={ratingContainerClass} ref={wrapperRef} style={style}>
            <input
                disabled={disabled}
                type="radio"
                id={"star5" + id}
                name={"rate" + id}
                value="5"
                checked={val === 5 ? true : false}
                onChange={(e) => handleChangeRate(e)}
            />
            <label className={labelClass} style={labelStyle} htmlFor={"star5" + id}>
                <CustomStar />
            </label>
            <input
                disabled={disabled}
                type="radio"
                id={"star4" + id}
                name={"rate" + id}
                value="4"
                checked={val === 4 ? true : false}
                onChange={(e) => handleChangeRate(e)}
            />
            <label className={labelClass} style={labelStyle} htmlFor={"star4" + id}>
                <CustomStar />
            </label>
            <input
                disabled={disabled}
                type="radio"
                id={"star3" + id}
                name={"rate" + id}
                value="3"
                checked={val === 3 ? true : false}
                onChange={(e) => handleChangeRate(e)}
            />
            <label className={labelClass} style={labelStyle} htmlFor={"star3" + id}>
                <CustomStar />
            </label>
            <input
                disabled={disabled}
                type="radio"
                id={"star2" + id}
                name={"rate" + id}
                value="2"
                checked={val === 2 ? true : false}
                onChange={(e) => handleChangeRate(e)}
            />
            <label className={labelClass} style={labelStyle} htmlFor={"star2" + id}>
                <CustomStar />
            </label>
            <input
                disabled={disabled}
                type="radio"
                id={"star1" + id}
                name={"rate" + id}
                value="1"
                checked={val === 1 ? true : false}
                onChange={(e) => handleChangeRate(e)}
            />
            <label className={labelClass} style={labelStyle} htmlFor={"star1" + id}>
                <CustomStar />
            </label>
        </div>
    );
};

export default Star;
